import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="social-links">
                <a href="https://robertsspaceindustries.com/orgs/CORVUSNOCTA" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-globe"></i> RSI
                </a>
                <a href="https://discord.com/invite/UeNx7kbkYv" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-discord"></i> Discord
                </a>
                <a href="https://www.instagram.com/corvusnocta/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i> Instagram
                </a>
            </div>
            <p>&copy; 2024 Federación Corvus Nocta. Todos los derechos reservados.</p>
        </footer>
    );
};

export default Footer; 